import { put, takeEvery, call } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { updatePickTourItem, updatePickTour, updatePickTourItemsAndExit } from '../actions/activePickTour.actions';
import { runUpdatePickTourItemSaga } from './updatePickTourItem.saga';
import { UpdatePickTourItemsAndExitPayload } from '../actions/activePickTour.types';

/**
 * Recursively processes pick tour item updates sequentially
 */
function* processItemUpdatesSequentially(
  itemUpdates: UpdatePickTourItemsAndExitPayload['itemUpdates'],
  paginationData: UpdatePickTourItemsAndExitPayload['paginationData'],
  index: number
): Generator<any, void, any> {
  if (index >= itemUpdates.length) {
    return;
  }

  const itemUpdate = itemUpdates[index];
  yield call(
    runUpdatePickTourItemSaga,
    updatePickTourItem({
      pickID: itemUpdate.pickID,
      pickedQuantity: itemUpdate.pickedQuantity,
      skipReason: itemUpdate.skipReason,
      isSkipped: itemUpdate.isSkipped,
      locationIndex: itemUpdate.locationIndex,
      nextPick: itemUpdate.nextPick,
      paginationData,
      isLastPick: itemUpdate.isLastPick,
    })
  );

  // Process next item
  yield call(processItemUpdatesSequentially, itemUpdates, paginationData, index + 1);
}

/**
 * This saga handles the exit pick tour flow by coordinating multiple pick item updates
 * followed by the pick tour exit. It ensures all item updates complete before
 * dispatching the exit action, preventing race conditions.
 */
export function* runUpdatePickTourItemsAndExitSaga(action: ReturnType<typeof updatePickTourItemsAndExit>) {
  const { itemUpdates, paginationData, updateStatus } = action.payload;

  // Process all item updates sequentially to ensure they complete before exit
  if (itemUpdates.length > 0) {
    yield call(processItemUpdatesSequentially, itemUpdates, paginationData, 0);
  }

  // After all item updates complete, dispatch the exit action
  yield put(updatePickTour({ updateType: 'exit', updateStatus }));
}

export default function* watchUpdatePickTourItemsAndExit() {
  yield takeEvery(getType(updatePickTourItemsAndExit), runUpdatePickTourItemsAndExitSaga);
}
